<template>
  <div class="panel_shouyin">
    <div class="titleLine">
      <el-row>
        <el-col :span="6"> </el-col>
        <el-col :span="6"> </el-col>
        <el-col :span="3" :offset="21">
          <el-button @click="back" size="mini">返回</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="con">
      <div class="L">
        <div class="label">接诊状态</div>
        <el-radio-group
          v-model="isTransfer"
          @change="changeIsTransfer"
          style="width: 250px; padding-bottom: 20px; padding-top: 5px"
        >
          <!-- <el-radio :label="true">是</el-radio>
					<el-radio :label="false">否</el-radio> -->
          <el-radio :label="1">初诊</el-radio>
          <el-radio :label="2">复诊</el-radio>
          <el-radio :label="3">转诊</el-radio>
        </el-radio-group>
        <div
          class="label"
          v-if="
            !$public.isNull(curBingli) &&
            !$public.isNull(
              $public.getMatchingItem(bingliList, 'caseNumber', curBingli)
                .diagnosisTags
            )
          "
          style="padding: 0 0 0 0px"
        >
          <div
            v-for="(item1, index1) in $public.getMatchingItem(
              bingliList,
              'caseNumber',
              curBingli
            ).diagnosisTags"
            :key="index1"
          >
            <span v-for="(item2, index2) in item1.symptom" :key="index2">
              {{ item1.value }}-{{ item2.value }}-{{
                item2.symptomLevel[0].value
              }}
            </span>
          </div>
          <!-- <div v-for="(item1,index1) in $public.getMatchingItem(bingliList,'caseNumber',curBingli).diagnosisTags" :key="index1">
						<span v-for="(item2,index2) in item1.symptom" :key="index2">
							{{item1.value}}-{{item2.value}}-{{item2.symptomLevel.value}} 
						</span>
					</div> -->
        </div>
        <div
          v-if="isTransfer !== 1"
          style="
            display: inline-block;
            padding-bottom: 20px;
            padding-top: 5px;
            vertical-align: middle;
            font-size: 14px;
            color: #73737b;
          "
        >
          病例信息：
          <el-select
            v-if="!$public.isNull(bingliList)"
            v-model="curBingli"
            @change="changeCurBingli"
            :disabled="$public.isNull(curPetInfo._id)"
            filterable
            placeholder="请选择"
            size="mini"
            style="width: 180px"
          >
            <el-option
              v-for="item in bingliList"
              :key="item.caseNumber"
              :label="item.caseNumber"
              :value="item.caseNumber"
            ></el-option>
          </el-select>
          <span v-else>无过往病例</span>
        </div>
        <div class="label">销售人员</div>
        <el-select
          v-model="handlerId"
          @change="changeHandlerId"
          multiple
          filterable
          placeholder="请选择"
          size="mini"
          style="width: 210px"
        >
          <el-option
            v-for="item in staffList"
            :key="item._id"
            :label="item.basic_info.nick_name"
            :value="item._id + ',' + item.basic_info.nick_name"
          ></el-option>
        </el-select>
        <div class="label" style="padding-top: 20px">值班医生</div>
        <div class="xmjBox">
          <div
            class="xmjItem"
            :class="doctor.split(',')[0] === item.userId ? 'active' : ''"
            @click="changeDoctor(item)"
            v-for="item in doctorList"
            :key="item.userId"
          >
            {{ item.userName }}
            <!-- <img class="checked"
						v-if="doctor.split(',')[0]===item.userId"
						src="../../../../assets/img/bottomRightChecked.png"
						>
						<img class="checked"
						v-else
						src="../../../../assets/img/bottomRightNoChecked.png"
						> -->
          </div>
        </div>
        <div class="label">科室</div>
        <div class="xmjBox">
          <div
            class="xmjItem"
            :class="department.split(',')[0] === item._id ? 'active' : ''"
            @click="changeDepartment(item)"
            v-for="item in departmentList"
            :key="item._id"
          >
            {{ item.name }}
            <!-- <img class="checked"
						v-if="department.split(',')[0]===item._id"
						src="../../../../assets/img/bottomRightChecked.png"
						>
						<img class="checked"
						v-else
						src="../../../../assets/img/bottomRightNoChecked.png"
						> -->
          </div>
        </div>
        <!-- <div class="label">诊室</div>
				<div class="xmjBox">
					<div class="xmjItem" :class="room.split(',')[0]===item.room_id?'active':''" @click="changeRoom(item)" v-for="(item) in roomList" :key="item.room_id">
						{{item.room_name}}
						<img class="checked"
						v-if="room.split(',')[0]===item.room_id"
						src="../../../../assets/img/bottomRightChecked.png"
						>
						<img class="checked"
						v-else
						src="../../../../assets/img/bottomRightNoChecked.png"
						>
					</div>
				</div> -->
      </div>
      <div class="R">
        <div
          v-for="(serviceItem, serviceIndex) in serviceList"
          :key="serviceIndex"
        >
          <div v-if="!$public.isNull(serviceItem.serviceId)">
            <div
              style="font-size: 16px; font-weight: bold; padding: 10px 20px 0px"
            >
              {{ serviceItem.title }}
            </div>
            <div class="roomBox">
              <div
                class="room"
                :class="[goodsId === skuItem.service_objectId ? 'active' : '']"
                @click="changeService(serviceItem, skuItem)"
                v-for="(skuItem, skuIndex) in serviceItem.serviceItems"
                :key="skuIndex"
              >
                <!-- <div class="tip">0/3</div> -->
                <!-- <img class="checked"
								v-if="goodsId===skuItem.service_objectId"
								src="../../../../assets/img/bottomRightChecked.png"
								>
								<img class="checked"
								v-else
								src="../../../../assets/img/bottomRightNoChecked.png"
								> -->
                <div class="roomName">{{ skuItem.service_objectName }}</div>
                <div class="roomPrice">￥{{ skuItem.price }}</div>
                <!-- <div class="roomPrice">早8：30 - 晚18：00</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 转诊
      isTransfer: 1,
      // 经办人
      handlerId: "",
      staffList: [],
      //医生
      doctor: "",
      doctorList: [],
      //科室
      department: "",
      departmentList: [],
      // 诊室
      // room:'',
      // roomList:[],
      // 挂号服务
      goodsId: "",
      serviceList: [],

      // 过往病例
      curBingli: "",
      bingliList: [],
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
        };
      }
    },
    curPetId() {
      return this.$store.state.mendian.curPetId;
    },
    curPetInfo() {
      return this.$store.getters["mendian/curPetInfo"];
    },
    addParams() {
      return this.$store.state.guahao.addParams;
    },
  },
  mounted() {
    this.getStaffList();
    this.getDoctorList();
    // this.getRoomList();
    this.getServiceList();
    this.getKeshiList();
    this.addParams.doctor = "";
    this.addParams.department = "";
    this.addParams.isTransfer = 1;
    // this.addParams.room = ''
    this.$store.commit("guahao/set_addParams", this.addParams);
    this.$store.state.mendian.userController.map((controller) => {
      if (controller.invitationType === 3 && controller.userId.length > 0) {
        this.handlerId = [controller.userId + "," + controller.userName];
      }
    });
    // 获取往期病例
    this.getBingliList();
  },
  methods: {
    // 返回
    back() {
      this.$store.commit("guahao/set_type", "list");
    },
    // 改变转诊
    changeIsTransfer() {
      this.curBingli = "";
      this.addParams.curBingli = "";
      this.addParams.isTransfer = this.isTransfer;
      this.$store.commit("guahao/set_addParams", this.addParams);
    },
    // 改变经办人
    changeHandlerId() {
      this.addParams.handlerId = this.handlerId;
      this.$store.commit("guahao/set_addParams", this.addParams);
    },
    // 改变医生
    changeDoctor(item) {
      console.log(item);
      let doctor = item.userId + "," + item.userName;
      if (this.doctor === doctor && this.doctor !== "") {
        this.doctor = "";
      } else {
        this.doctor = doctor;
      }
      this.addParams.doctor = this.doctor;
      this.$store.commit("guahao/set_addParams", this.addParams);
    },
    // 改变科室
    changeDepartment(item) {
      let department = item._id + "," + item.name;
      if (this.department === department && this.department !== "") {
        this.department = "";
      } else {
        this.department = department;
      }
      this.addParams.department = this.department;
      this.$store.commit("guahao/set_addParams", this.addParams);
    },
    // 改变诊室
    // changeRoom(item){
    // 	let room = item.room_id+','+item.room_name
    // 	if(this.room === room&&this.room!==''){
    // 		this.room = ''
    // 	}else{
    // 		this.room = room
    // 	}
    // 	this.addParams.room = this.room
    // 	this.$store.commit('guahao/set_addParams',this.addParams)
    // },
    // 挂号服务
    changeService(serviceItem, skuItem) {
      this.goodsId = skuItem.service_objectId;
      this.addParams.skuItem = skuItem;
      this.addParams.serviceItem = serviceItem;
      // this.addParams.activityPrice = serviceItem.price;  // 挂号不参与活动
      this.$store.commit("guahao/set_addParams", this.addParams);
      this.$store.commit("guahao/set_money", skuItem.price);
      this.$store.commit("guahao/set_activityMoney", skuItem.price);
      // this.getActivityList(serviceItem)  // 挂号不参与活动
    },
    getServiceList() {
      let params = {
        keyword: "",
        // "applytype": '0,'+this.curPetInfo.class_type, // 应用分类 0:通用 1:猫 2:犬
        applytype: "0", // 应用分类 0:通用 1:猫 2:犬
        categoryId: "", // 分类编号
        categoryCode: "register", // 分类编码handle(处置) operation(手术) detection(检查) ward(病房) register(挂号)
        pageIndex: 1,
        pageSize: 500,
      };
      let loading = this.$loading();
      this.$http
        .post("/api/Product/ProductMedical/SimpleList", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            let list = res.data.data;
            let arr = [{}, {}, {}, {}, {}, {}, {}];
            for (let i = 0; i < list.length; i++) {
              if (list[i].category_info._id === "601d11d0a93f55b5cf3ae302") {
                // 普通
                arr[0] = list[i];
              } else if (
                list[i].category_info._id === "6055672e99455dafa9f06586"
              ) {
                // 专科
                arr[1] = list[i];
              } else if (
                list[i].category_info._id === "601d11d0a93f55b5cf3ae304"
              ) {
                // 专家
                arr[2] = list[i];
              } else if (
                list[i].category_info._id === "60546a14b77fa2681ea3708a"
              ) {
                // 复诊
                arr[3] = list[i];
              } else if (
                list[i].category_info._id === "60545dd2341ae9ae311cf679"
              ) {
                // 夜诊
                arr[4] = list[i];
              } else if (
                list[i].category_info._id === "60546be90b69e10e27f8e6ca"
              ) {
                // 会诊
                arr[5] = list[i];
              } else if (
                list[i].category_info._id === "60545f5f341ae9ae311cfd53"
              ) {
                // 出诊
                arr[6] = list[i];
              }
            }
            this.serviceList = arr;
          }
        });
    },
    // formatServiceList(arr){
    // 	var result = [];
    // 	for (let i = 0; i <arr.length; i++) {
    // 		let item1=JSON.parse(JSON.stringify(arr[i]));
    // 		delete item1.service_info
    // 		for(let a=0;a<arr[i].service_info.length;a++){
    // 			let item2 = arr[i].service_info[a]
    // 			let aaa = JSON.parse(JSON.stringify(item1))
    // 			Object.assign(aaa,item2)
    // 			result.push(aaa)
    // 		}
    // 	}
    // 	for (let i = 0; i <result.length; i++) {
    // 		let sz = []
    // 		for(let q=0;q<result[i].service_items.length;q++){
    // 			let item1 = JSON.parse(JSON.stringify(result[i].service_items[q]))
    // 			delete item1.service_object
    // 			for(let a=0;a<result[i].service_items[q].service_object.length;a++){
    // 				let item2 = JSON.parse(JSON.stringify(result[i].service_items[q].service_object[a]))
    // 				let aaa = JSON.parse(JSON.stringify(item1))
    // 				Object.assign(aaa,item2)
    // 				sz.push(aaa)
    // 			}
    // 		}
    // 		result[i].service_items=sz
    // 	}
    // 	console.log(result)
    // 	return result;
    // },
    // 获取销售人员列表
    getStaffList() {
      let params = {
        keyword: "",
        pageIndex: 1,
        pageSize: 500,
      };
      this.$http.get("/api/Staff/MedicalStaffList", params).then((res) => {
        if (res.code == 0) {
          this.staffList = res.data.data;
        }
      });
    },
    // 获取值班医生
    getDoctorList() {
      let params = {
        date: "", // 10位时间戳
      };
      this.$http.get("/api/Registration/DutyForDay", params).then((res) => {
        if (res.code == 0) {
          this.doctorList = res.data;
        }
      });
    },
    // 获取科室
    getKeshiList() {
      let loading = this.$loading();
      this.$http.get("/api/Registration/Department/List", {}).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.departmentList = res.data;
        }
      });
    },
    // 获取诊室
    // getRoomList(){
    // 	let params = {
    // 		roomType:12, // 房间类型 1:寄养室 2:美容室 3:住院部 4:手术室 5:隔离室 6:传染病房 7:猫房 8:等待室 9:洗护室 10:大厅展示区 11:大厅 12:诊疗室
    // 	}
    // 	let loading = this.$loading()
    // 	this.$http.get('/api/Data/ShopRoom', params).then(res => {
    // 		loading.close()
    // 		if (res.code == 0) {
    // 			this.roomList = res.data;
    // 		}
    // 	})
    // },
    // 修改当前病例
    changeCurBingli(caseNumber) {
      this.curBingli = caseNumber;
      this.addParams.curBingli = caseNumber;
      this.$store.commit("guahao/set_addParams", this.addParams);
    },
    // 获取当前用户的过往病例
    getBingliList() {
      let params = {
        memberId: this.userInfo._id,
        departmentId: "",
        petId: "",
        isPay: -1, // -1不限；0未支付；1已支付
        isInspect: -1, // -1不限；0未检测；1已检测
        isVisit: -1, // -1不限；0未回访；1已回访
        isEnter: -1,
        showLater: false,
        desc: true, // true  倒序  false 正序
        begin_time: "",
        end_time: "",
        pageIndex: 1,
        pageSize: 500,
        keyword: "",
      };
      let loading = this.$loading();
      this.$http.post("/api/Case/List", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.bingliList = res.data.data;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.panel_shouyin {
  height: 100%;
  padding-bottom: 60px;
  box-sizing: border-box;
  position: relative;
  background-color: #f5f5f5;
  .titleLine {
    width: 100%;
    background-color: #fff;
    height: 44px;
    padding: 8px 8px;
    box-sizing: border-box;
    margin-bottom: 4px;
    position: absolute;
    z-index: 1;
  }
  .con {
    display: flex;
    padding: 30px 0px 70px 0px;
    background-color: #fff;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 50px;
    position: absolute;
    top: 0;
    .L {
      width: 474px;
      border-right: 1px solid #f5f5f5;
      flex-shrink: 0;
      box-sizing: border-box;
      overflow: auto;
      padding: 0 20px;
      &::-webkit-scrollbar {
        width: 4px;
        // height: 4px;
      }
      .label {
        font-size: 14px;
        padding-bottom: 10px;
      }
      .xmjBox {
        display: flex;
        justify-content: flex-start;
        padding: 10px 0px 10px;
        flex-wrap: wrap;
        .xmjItem {
          position: relative;
          width: 92px;
          box-sizing: border-box;
          line-height: 44px;
          text-align: center;
          border: 1px solid #dadada;
          font-size: 14px;
          color: #666;
          cursor: pointer;
          margin-bottom: 10px;
          margin-right: 15px;
          border-radius: 4px;
          &.active {
            border-color: $mainColor;
            color: $mainColor;
          }
          // .checked{
          // 	position: absolute;right:0;bottom:0;width:26px;height: 13px;text-align: center;color:#fff;
          // }
        }
      }
    }
    .R {
      width: 100%;
      height: 100%;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 4px;
        // height: 4px;
      }
      .col {
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        .RLabel {
          font-size: 14px;
          color: #6e6e6e;
          text-align: right;
          line-height: 28px;
        }
      }
      .roomBox {
        display: flex;
        padding: 10px 70px 10px 50px;
        flex-wrap: wrap;
        .room {
          position: relative;
          width: 174px;
          height: 100px;
          border: 1px solid #ccc;
          box-sizing: border-box;
          background-color: #e8e8e8;
          margin: 10px 20px;
          text-align: center;
          cursor: pointer;
          border-radius: 4px;
          .mask {
            position: absolute;
            top: -2px;
            left: -2px;
            z-index: 10;
            width: 210px;
            height: 110px;
            background-color: rgba(0, 0, 0, 0.5);
          }
          .tip {
            position: absolute;
            top: -2px;
            left: -2px;
            width: 55px;
            height: 20px;
            text-align: center;
            color: #fff;
            background-color: #ffae11;
            font-size: 12px;
            line-height: 20px;
          }
          .checked {
            position: absolute;
            right: -2px;
            bottom: -2px;
            width: 40px;
            height: 18px;
            text-align: center;
            color: #fff;
          }
          .roomName {
            font-size: 16px;
            color: #666666;
            padding-top: 28px;
            font-weight: bold;
          }
          .roomPrice {
            font-size: 14px;
            color: #666666;
            padding-top: 10px;
          }
          &.active {
            background-color: $mainColor;
            border-color: $mainColor;
            .roomName {
              color: #fff;
              padding-top: 25px;
            }
            .roomPrice {
              color: #fff;
              padding-top: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
